import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="2">
      <path d="M14 19H2V7h3l2-3h8l2 3h3v3M20 12v8M16 16h8" />
      <circle cx="11" cy="12" r="3" />
      <path d="M21 4h-3" />
    </g>
  </svg>
);
